<template>
  <div class="login">
    <!-- <div>
      <b-img fluid :src="this.logoLarge"></b-img>
    </div> -->
    <div>
      <h1>Welcome to ReadyMsg</h1>
    </div>

    <div>
      <p class="mt-4">Sign-in or create your trial account below.</p>
    </div>
    <div class="mt-5" id="firebaseui-auth-container"></div>
    <div id="loader">Loading...</div>
  </div>
</template>

<script>
import firebase from 'firebase'
import firebaseui from 'firebaseui'
export default {
  name: 'login',
  data () {
    return {
    //   logoLarge: require('../assets/incentiv-logo-large.png'),
    loginSuccess: '/add-business'
    }
  },
  created () {

  },
  mounted () {
    const ui = new firebaseui.auth.AuthUI(firebase.auth())
    var uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: function (authResult, redirectUrl) {
          // User successfully signed in.
          // Return type determines whether we continue the redirect automatically
          // or whether we leave that to developer to handle.
          return true
        },
        uiShown: function () {
          // The widget is rendered.
          // Hide the loader.
          document.getElementById('loader').style.display = 'none'
        }
      },
      // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
      // signInFlow: 'popup',
      signInSuccessUrl: this.loginSuccess,
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        // firebase.auth.PhoneAuthProvider.PROVIDER_ID
      ],
      // Terms of service url.
      tosUrl: 'http://readymsg.me/terms',
      // Privacy policy url.
      privacyPolicyUrl: 'http://readymsg.me/privacy'
    }
    ui.start('#firebaseui-auth-container', uiConfig)

    // if (ui.isPendingRedirect()) {
    //   ui.start('#firebaseui-auth-container', uiConfig);
    // }
  }
}
</script>

<style scoped>
  .login {
    padding-top: 130px;
  }
</style>
